import React from 'react';
import Evals from '../EvaluationComponents/Evals';

/**
 * CandidateEvals Component
 * Wrapper for the shared Evals component with candidate context
 */
const CandidateEvals = ({ candidate, ...props }) => {
  // Log the candidate object for debugging
  console.log('CandidateEvals - candidate prop:', candidate);
  
  return <Evals entity={candidate} contextType="candidate" {...props} />;
};

export default CandidateEvals;
